import { BaseForm } from '@forms/base.form';
import { Component, Input } from '@angular/core';
import { Payroll } from '@models/payroll/payroll.model';

@Component({
    selector: 'app-form-payroll-off-cycle',
    templateUrl: './payroll-off-cycle.template.html',
    styleUrls: ['./payroll-off-cycle.style.scss'],
})
export class PayrollOffCycleForm extends BaseForm {
    @Input() payroll: Payroll = new Payroll({ addAllEmployees: false });

    minDate = new Date(); // off cycle payroll cannot be in the past
}
